import React, { useState, useEffect } from "react";
import { Table, Button, Modal } from "antd";
import { useParams } from "react-router-dom";
import { useLocation } from "react-router-dom";
import Cookies from "js-cookie";
import { firebaseAPI } from "../firebaseConfig";
import axios from "axios";
import "../dell.css";
import axiosInstance from "../utils/axiosInstance";

const ParticipantTable = ({ participants, programName, fetchParticipants }) => {
  const [programRounds, setProgramRounds] = useState([]);
  const { formName } = useParams();
  const location = useLocation(); // Hook to get current location
  const fetchProgramRounds = async () => {
    try {
      // Extract program name from URL
      const programName = location.pathname.split("/")[1]; // Assuming program name is the first part of the path

      // Fetch program rounds from backend
      const response = await axiosInstance.get(
        `${firebaseAPI}/program/${programName}/rounds`
      );
      const { programRounds } = response.data;

      // Set program rounds
      setProgramRounds(programRounds);
    } catch (error) {
      console.error("Error fetching program rounds:", error);
    }
  };
  useEffect(() => {
    // Fetch program rounds when the component mounts or when location changes
    fetchProgramRounds();
  }, [location.pathname]);

  const handleQualify = async (userEmail, submissionId) => {
    Modal.confirm({
      title: "Are you sure?",
      content: "Are you sure you want to mark this submission as qualified?",
      onOk: async () => {
        try {
          let token = Cookies.get("token") || "";
          const currentRoundIndex = programRounds.indexOf(formName);
          let nextRound;

          if (currentRoundIndex === programRounds.length - 1) {
            // If it's the last round, remain the same
            nextRound = formName;
          } else {
            // Otherwise, get the next round
            nextRound = programRounds[currentRoundIndex + 1];
          }

          await axiosInstance.post(
            `${firebaseAPI}/qualify`,
            {
              roundName: formName,
              userEmail: userEmail,
              programName: programName,
            },
            {
              headers: {
                Authorization: `Bearer ${token}`,
              },
            }
          );

          fetchParticipants();
        } catch (error) {
          console.error("Error qualifying user:", error);
        }
      },
      onCancel: () => {
        ////console.log('Cancel');
      },
      okText: "Yes",
      cancelText: "No",
    });
  };

  const handleDisqualify = async (userEmail, submissionId) => {
    Modal.confirm({
      title: "Are you sure?",
      content: "Are you sure you want to disqualify this submission?",
      onOk: async () => {
        try {
          let token = Cookies.get("token") || "";
          await axiosInstance.post(
            `${firebaseAPI}/disqualify`,
            {
              roundName: formName,
              userEmail: userEmail,
              programName: programName,
            },
            {
              headers: {
                Authorization: `Bearer ${token}`,
              },
            }
          );

          fetchParticipants();
        } catch (error) {
          console.error("Error disqualifying user:", error);
        }
      },
      onCancel: () => {
        ////console.log('Cancel');
      },
      okText: "Yes",
      cancelText: "No",
    });
  };

  const handlePending = async (userEmail, submissionId) => {
    Modal.confirm({
      title: "Are you sure?",
      content: "Are you sure you want to mark this submission as pending?",
      onOk: async () => {
        try {
          let token = Cookies.get("token") || "";
          await axiosInstance.post(
            `${firebaseAPI}/pending`,
            {
              roundName: formName,
              userEmail: userEmail,
              programName: programName,
            },
            {
              headers: {
                Authorization: `Bearer ${token}`,
              },
            }
          );

          fetchParticipants();
        } catch (error) {
          console.error("Error marking user as pending:", error);
        }
      },
      onCancel: () => {
        ////console.log('Cancel');
      },
      okText: "Yes",
      cancelText: "No",
    });
  };
  const columns = [
    {
      title: "Name",
      dataIndex: ["name"], // Access nested 'name'
      key: "name",
    },
    {
      title: "Email",
      dataIndex: ["email"], // Access nested 'email'
      key: "email",
    },
    {
      title: "Participant CV",
      dataIndex: ["cvUrl"],
      key: "participant_cv",
      render: (cvUrl) => (
        <Button
          type="link"
          href={cvUrl}
          target="_blank"
          rel="noopener noreferrer"
        >
          View CV
        </Button>
      ),
    },
    {
      title: "Graduation Year",
      dataIndex: "gradYear", // Match the case of 'gradYear'
      key: "gradYear",
      sorter: (a, b) => a.gradYear - b.gradYear, // Add sorter function
      sortDirections: ["ascend", "descend"], // Add sortDirections property
    },
    {
      title: "University",
      dataIndex: "university", // No change needed
      key: "university",
    },
    // Assuming you have a 'status' field in your new JSON
    {
      title: "Status",
      dataIndex: "profileStatus",
      key: "status",
      render: (text) => {
        let color, backgroundColor;
        switch (text) {
          case "pending":
            color = "#000";
            backgroundColor = "#FFECB3"; // Pastel yellow
            break;
          case "qualified":
            color = "#000";
            backgroundColor = "#81C784"; // Pastel green
            break;
          case "disqualified":
            color = "#000";
            backgroundColor = "#E57373"; // Pastel red
            break;
          default:
            color = "#000";
            backgroundColor = "#FFF";
        }
        return (
          <span
            style={{
              color,
              backgroundColor,
              padding: "4px",
              borderRadius: "4px",
            }}
          >
            {text}
          </span>
        );
      },
    },
    {
      title: "Change Status To",
      key: "change_status",
      render: (text, record) => (
        <span className="status-buttons">
          <Button
            onClick={
              () => handlePending(record.email)
              ////console.log(record)
            }
            style={{ color: "black", borderColor: "black" }}
          >
            Pending
          </Button>
          <Button
            onClick={() => handleQualify(record.email)}
            style={{ color: "#81C784", borderColor: "#81C784" }}
          >
            Qualified
          </Button>
          <Button
            onClick={() => handleDisqualify(record.email)}
            style={{ color: "#E57373", borderColor: "#E57373" }}
          >
            Disqualified
          </Button>
        </span>
      ),
    },
    // Add additional columns for new fields if needed
  ];
  const rowClassName = () => "white-row"; // Custom class for rows with white background

  ////console.log(participants)

  // Convert the participants data to match the expected format for the Table
  const dataSource = participants.map((participant) => {
    // Find the participant's program entry for the given program name
    const programEntry = participant.participantPrograms.find(
      (program) => program.programName === programName
    );

    // Extract the profileStatus from the program entry, or default to an empty string if not found
    const profileStatus = programEntry ? programEntry.profileStatus : "";

    return {
      key: participant._id, // Use _id as the unique key for each row
      name: participant.user.name,
      email: participant.user.email,
      gradYear: participant.gradYear,
      university: participant.university,
      profileStatus: profileStatus,
      cvUrl: participant.cvUrl,
    };
  });

  return (
    <div className="participant-table-container">
      <Table
        dataSource={dataSource} // Use the converted dataSource
        columns={columns}
        className="dell-table"
        rowClassName={rowClassName}
      />
    </div>
  );
};

export default ParticipantTable;
